









































import { Component, Vue } from "vue-property-decorator";
import FormCard from "@/components/FormCard.vue";
import MailConfiguration from "@/views/Configuration/MailConfiguration.vue";
import ConfigurationsTexts from "@/views/Configuration/ConfigurationsTexts.vue";
import BKFConfigs from "@/views/Configuration/BKFConfigs.vue";
import DriveBuzzConfiguration from "@/views/Configuration/DriveBuzzConfiguration.vue";
import LicenseSlotsConfiguration from "@/views/Configuration/LicenseSlotsConfiguration.vue";
import SignatureConfiguration from "@/views/Configuration/SignatureConfiguration.vue";
import FscCard from "@/components/Card/FscCard.vue";
import CheckListConfiguration from "@/views/Configuration/CheckListConfiguration.vue";
import Switches from "@/views/Configuration/Switches.vue";
import TestingOrganization from "@/views/Configuration/TestingOrganization/TestingOrganization.vue";
import DashboardWarnings from "@/views/Configuration/DashboardWarnings.vue";
import StudentCategories from "@/views/Configuration/StudentCategories/StudentCategories.vue";
import DrivingLessonTaskGroups from "@/views/Configuration/DrivingLessonTaskGroups/DrivingLessonTaskGroups.vue";

@Component({
  components: {
    FscCard,
    LicenseSlotsConfiguration,
    ConfigurationsTexts,
    BKFConfigs,
    DriveBuzzConfiguration,
    MailConfiguration,
    FormCard,
    SignatureConfiguration,
    CheckListConfiguration,
    Switches,
    TestingOrganization,
    DashboardWarnings,
    StudentCategories,
    DrivingLessonTaskGroups,
  },
})
export default class Configurations extends Vue {
  public name = "Configurations";
}
